import React, { Suspense, lazy } from "react";
import { Redirect, BrowserRouter, Switch, Route } from "react-router-dom";
import { useStoreState } from "easy-peasy";
import "App.scss";

import routes from "routes";
import { isEmpty } from "utils/utils";
import Loader from "components/Loader";

const AuthRoutes = lazy(() => import("routes/auth/Routes"));
const Navigation = lazy(() => import("components/Navigation"));
const SessionLogoutPopup = lazy(() => import("components/SessionLogoutPopup"));

const App = () => {
  const authToken = useStoreState(state => state.auth.authToken);
  const isShowSessionLogoutPopup = useStoreState(
    state => state.auth.isShowSessionLogoutPopup,
  );
  const isLoader = useStoreState((state) => state.misc.isLoader);

  return (
    <div className="page-container">
      {isShowSessionLogoutPopup ? <SessionLogoutPopup /> : undefined}
      {isLoader && <Loader />}
      <BrowserRouter>
        <Suspense fallback={<Loader />}>
          <Switch>
            <Route path={routes.auth} component={AuthRoutes} />
            {!isEmpty(authToken) && <Route path="/" component={Navigation} />}
            {isEmpty(authToken) && <Redirect to={routes.auth} />}
          </Switch>
        </Suspense>
      </BrowserRouter>
    </div>
  );
};
export default App;
